module.exports = __webpack_public_path__ + "static/media/20.40c00f67.jpg";